import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@components/atoms/typography';
import { Modal } from '@components/moleculs/modal';
import { ModalBody } from '@components/moleculs/modal/styles';
import { Box } from '@mui/material';

type RestrictedCountriesModalProps = {
    open: boolean;
    onClose: () => void;
};

export const RestrictedCountriesModal: React.FC<RestrictedCountriesModalProps> = ({
    open,
    onClose,
}) => {
    const { t } = useTranslation();

    return (
        <Modal open={open} onClose={onClose} hasCloser={true}>
            <ModalBody>
                <Box sx={{ p: 3, pr: 5 }}>
                    <Typography tag='h3' variant='big-text-bold' color='text-main'>
                        {t('docVerificationWidget.startCustomPartner.restrictedCountries.title')}
                    </Typography>
                    <Typography tag='p' variant='text' color='text-main' sx={{ mt: 1.5 }}>
                        {t('docVerificationWidget.startCustomPartner.restrictedCountries.list')}
                    </Typography>
                </Box>
            </ModalBody>
        </Modal>
    );
};
